module.exports = __webpack_public_path__ + "static/img/logo-new.1649ca3f.png";